(() => {
  if (window.npsMobileMenuReady) return;
  window.npsMobileMenuReady = true;

  const resetMenus = () => {
    document.querySelectorAll('xo-modal.nps-mobile-menu__modal').forEach((modal) => {
      const startOpen = modal.dataset.npsAccordionStartOpen === 'true';
      modal.querySelectorAll('details.nps-mobile-menu__accordion').forEach((accordion) => {
        accordion.open = startOpen;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetMenus, { once: true });
  } else resetMenus();
  document.addEventListener('shopify:section:load', resetMenus);

  customElements.whenDefined('xo-modal').then(() => {
    let wasOpen = false;
    window.xoStore.subscribe('xo-modal', (state) => {
      const isOpen = Boolean(state?.data?.['xo-menu-hamburger']?.isOpen);
      if (isOpen && !wasOpen) resetMenus();
      wasOpen = isOpen;
    });
  });
})();
